export default "__VITE_ASSET__DOx2q8Ai__"